import type { ComplianceCaseCreate } from "../types";

/** One-click timber DE→DE demo case (US-308). */
export const TIMBER_DE_DEMO_PRESET: ComplianceCaseCreate = {
  author_party_role: "importer_operator",
  commodity: "timber",
  supplier_name: "Demo Forst GmbH",
  supplier_country: "DE",
  supplier_contact: "demo-supplier@example.com",
  buyer_name: "Demo Import AG",
  buyer_country: "DE",
  destination_country: "DE",
  contract_reference: "DEMO-TIMBER-DE-DE",
  shipment_volume: 120,
  shipment_unit: "m3",
};

export function isTimberDeDemoPreset(values: Partial<ComplianceCaseCreate>): boolean {
  return (
    values.commodity === "timber" &&
    values.supplier_country === "DE" &&
    values.buyer_country === "DE" &&
    values.destination_country === "DE"
  );
}
